import React, { FC, useState, useEffect } from "react";
import styled from "styled-components";
import { Row, Form, Input, Col, notification, Spin } from "antd";
import { useStoreActions, useStoreState } from '../../../myStore';
import { PrimaryButtonX } from "../../../Components/Button3D";
import { useHistory } from "react-router-dom";
import Img3D from "../../../Components/Model3D";
import { uploadtoS3 } from '../../../Api';
import { replaceError } from '../../../utils/utilsFunctions'
// import { GET_THUMBNAIL } from '../../../Apollo/graphql/Mutation/GetThumbnail';
import { CREATE_DESIGN } from '../../../Apollo/graphql/Mutation/DesignsMutations';
import { useMutation } from "@apollo/client";
import { GENERATE_PRE_SIGNED_URL_MUTATION } from '../../../Apollo/graphql/Mutation/UploadFile';
import { MY_DESIGNS } from "../../../Apollo/graphql/Query";


const MainContainer = styled(Row)`
`;
const ContentDiv = styled.div`
  width: 100%;
  background: white;
  padding: 1rem 0;
  /* margin: 2rem; */
`;
const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee;
`;
const InfoText = styled.span`
  color: #1890ff;
`;
const image3dStyle = {
    top: 0,
    right: 0,
    alignItems: "center",
    height: "100%",
    width: "100%",
}


const InfoPage: FC = () => {
    const history = useHistory();
    const [thumbnailImage, setThumbnailImage] = useState(null);

    const [loading, setLoading] = useState(false);
    const [currentProgressTitle, setCurrentProgressTitle] = useState<any>('');
    const [uploadDesignUrl, setUploadDesignUrl] = useState("");

    const designFormData = useStoreState((state) => state.design.designFormData);
    const setDesignFormData = useStoreActions((actions) => actions.design.setDesignFormData);

    const [createDesignMutation] = useMutation(CREATE_DESIGN);
    // const [getThumbnailMutation] = useMutation(GET_THUMBNAIL);
    const [uploadFileMutation] = useMutation(GENERATE_PRE_SIGNED_URL_MUTATION);

    useEffect(() => {
        if (designFormData.rawFile) {
            setUploadDesignUrl(URL.createObjectURL(designFormData.rawFile[0].originFileObj));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [designFormData.rawFile]);

    const uploadFile = async (fileList: any) => {
        setCurrentProgressTitle("Uploading design file...");
        let images: string[] = [];
        for (let i = 0; i < fileList.length; i++) {
            let file = fileList[i].originFileObj;
            try {
                const {
                    data: {
                        generate3dPreSignedURL: { url },
                    },
                } = await uploadFileMutation({
                    variables: {
                        input: {
                            type: "put",
                            fileId: file.uid,
                            mime: file.name.includes(".stl") ? "model/stl" : file.type,
                        },
                    },
                });
                if (url) {
                    await uploadtoS3(url, file)
                        .then((data) => {
                            images.push(url.split("?")[0]);
                        })
                        .catch((err) => {
                            console.log("Error: ", err);
                        });
                }
            } catch (err) {
                setLoading(false);
                return false;
            }
        }
        return images;
    };
    // const createThumbnail = async (files: any) => {
    //     setCurrentProgressTitle("Generating thumbnail...");
    //     try {
    //         const {
    //             data: {
    //                 getSTLThumbnail: { success, url },
    //             },
    //         } = await getThumbnailMutation({
    //             variables: {
    //                 input: {
    //                     url: files,
    //                 },
    //             },
    //         });
    //         if (success) {
    //             setLoading(false)
    //             return { thumbnail: url };
    //         }
    //         return { thumbnail: null };
    //     } catch (err) {
    //         setLoading(false)
    //         return {
    //             thumbnail: null,
    //         };
    //     }
    // };

    const handleSaveClick = async (values) => {
        setLoading(true);
        try {
            const fileRes = await uploadFile(designFormData?.rawFile);
            let finalThumbnail = '';
            if (designFormData.thumbnailFile && designFormData.thumbnailFile?.length !== 0) {
                const thumbneilFiles = await uploadFile(designFormData?.thumbnailFile);
                // const { thumbnail } = await createThumbnail(thumbneilFiles[0]);
                finalThumbnail = thumbneilFiles[0];
            } else {
                const thumbneilFiles = await uploadFile(thumbnailImage);
                finalThumbnail = thumbneilFiles[0];
            }
            // const { thumbnail } = await createThumbnail(fileRes[0]);
            setCurrentProgressTitle('Uploading design');
            const res = await createDesignMutation({
                variables: {
                    input: {
                        name: values.designName,
                        description: values.description,
                        featuredImage: !finalThumbnail ? thumbnailImage : finalThumbnail,
                        summary: values.summary || '',
                        design: fileRes[0],
                        images: fileRes,
                        marketPlaceType: designFormData.marketPlaceType,
                        price: designFormData.designPrice ? designFormData.designPrice : null,
                    }
                }, refetchQueries:[{query: MY_DESIGNS, variables: {pagination: {page: 1, limit: 100}}}],
            });
            if (res) {
                notification.success({
                    message: "Success",
                    description: "Design Created Successfully"
                })
                setDesignFormData({});
                history.push('/dashboard/designs');
            }
            setLoading(false);
        } catch (err) {
            notification.error({
                message: "Error",
                description: replaceError(err),
            })
            setLoading(false);
        }
    }

    return (
        <Spin spinning={loading} tip={currentProgressTitle}>
            <MainContainer>
                <ContentDiv>
                    <Col span={20} offset={2}>
                        <h1>Please fill the information about your Design</h1>
                        <Row>
                            <Col span={11}>
                                <ImgDiv>
                                    {
                                        uploadDesignUrl && <Img3D
                                            url={uploadDesignUrl}
                                            style={image3dStyle}
                                            autoScreenshot
                                            setThumbnailImage={setThumbnailImage}
                                        />
                                    }
                                    {
                                        !uploadDesignUrl && <p>File is not selected</p>
                                    }

                                </ImgDiv>
                            </Col>
                            <Col span={12} offset={1}>
                                <Form
                                    name="basic"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    onFinish={handleSaveClick}
                                    initialValues={{ remember: true }}
                                    autoComplete="off"
                                >
                                    <Form.Item
                                        label="DesignName"
                                        name="designName"
                                        rules={[{ required: true, message: 'Please input your Design Name!' }]}
                                    >
                                        <Input
                                            style={{ height: '50px' }}
                                            placeholder="Enter your design name"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label="Description"
                                        name="description"
                                    // rules={[{ required: true, message: 'Please input  description!' }]}
                                    >
                                        <Input.TextArea
                                            placeholder="write some description about your design"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Summary"
                                        name="summary"
                                    // rules={[{ message: 'Please input  summary!' }]}
                                    >
                                        <Input.TextArea
                                            placeholder="write summary"
                                            rows={4}
                                        />
                                    </Form.Item>
                                    <div>
                                        <Form.Item>
                                            <PrimaryButtonX type='primary' style={{ marginTop: '1rem', width: '100%' }} disabled={!thumbnailImage} htmlType='submit'>Save Design</PrimaryButtonX>
                                            {!thumbnailImage && (
                                                <InfoText>
                                                    Please wait for a model to render in the left.
                                                </InfoText>
                                            )}
                                        </Form.Item>
                                    </div>

                                </Form>
                            </Col>
                        </Row>


                    </Col>
                </ContentDiv>
            </MainContainer>
        </Spin>
    );
};

export default InfoPage;